module.exports = __webpack_public_path__ + "img/service-xindai2.4a959171.svg";